module.exports = __webpack_public_path__ + "static/media/cleaning.bd9e2587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/cleaning.svg
// module id = 535
// module chunks = 0